export default __webpack_public_path__ + "static/media/SPECIFY_ID.94446140.svg";